<template>
    <div>
        <v-row no-gutters class="mb-2">
            <v-col cols="12" class="py-1 pl-1 subtitle-2 primary--text">
                {{$t('ubicacion')}}
                <v-divider></v-divider>
            </v-col>
        </v-row>

        <escenario-opcion-componente :nombre="$t('provincia')" :descripcion="$t('provincia_descrip')">
            <template v-slot:seleccion>
                <escenario-seleccion-componente
                        :escenario="escenario"
                        campo-id="codigo"
                        campo-nombre="nombre"
                        :opciones="provincias"
                        propiedad="province"
                        descripcion="Seleccionar provincia"
                        @change="seleccionarProvincia">
                </escenario-seleccion-componente>
            </template>
        </escenario-opcion-componente>

        <escenario-opcion-componente :nombre="$t('altitud')" :descripcion="$t('altitud_descrip')">
            <template v-slot:seleccion>
                <div class="font-italic font-weight-bold pa-2 caption" v-if="escenario && escenario.province == null">
                    {{$t('selec_provincia_antes')}}
                </div>
                <escenario-seleccion-componente
                        v-if="escenario && escenario.province != null"
                        :escenario="escenario"
                        campo-id="descripcion"
                        campo-nombre="descripcionVista"
                        :opciones="altitudes"
                        propiedad="altitude"
                        :descripcion="$t('selecciona_altitud')"
                        @change="seleccionarAltitud">
                </escenario-seleccion-componente>
            </template>
        </escenario-opcion-componente>

        <v-row v-if="escenario.climaticZone !== null" no-gutters>
            <v-col cols="12" class="py-2 pl-1 subtitle-2 primary--text">
                {{$t('climatica_consid')}}:&nbsp;<span class="font-weight-bold">{{escenario.climaticZone.codigo}}</span>
            </v-col>
        </v-row>

        <escenario-opcion-componente :nombre="$t('anyo_construccion')" :descripcion="$t('anyo_construccion_descrip')">
            <template v-slot:seleccion>
                <escenario-seleccion-componente
                        :escenario="escenario"
                        campo-id="code"
                        campo-nombre="name"
                        :opciones="anyosConstruccion"
                        propiedad="yearConstruction"
                        descripcion="Selecciona un año..."
                        @change="seleccionarAnyoConstruccion">
                </escenario-seleccion-componente>
            </template>
        </escenario-opcion-componente>

        <escenario-opcion-componente :nombre="$t('conservacion')" :descripcion="$t('conservacion_descrip')">
            <template v-slot:seleccion>
                <escenario-seleccion-componente
                        :escenario="escenario"
                        campo-id="code"
                        campo-nombre="name"
                        :opciones="estadosConservacion"
                        propiedad="stateConservation"
                        descripcion="Selecciona un estado..."
                        @change="seleccionarConservacion">
                </escenario-seleccion-componente>
            </template>
        </escenario-opcion-componente>

        <escenario-opcion-componente :nombre="$t('revestimiento')"
                                     :descripcion="$t('revestimiento_descrip')"
                                     v-if="escenario.stateConservation !== null && escenario.stateConservation.code === 'facade_deteriorated'"
        >
            <template v-slot:seleccion>
                <escenario-seleccion-componente
                        :escenario="escenario"
                        campo-id="code"
                        campo-nombre="name"
                        :opciones="revestimientos"
                        propiedad="existingCoating"
                        descripcion="Selecciona el revestimiento..."
                        @change="seleccionarRevestimiento">
                </escenario-seleccion-componente>
            </template>
        </escenario-opcion-componente>
    </div>
</template>

<script>
    import {HttpHelper} from "../../../../../comunes/helpers/HttpHelper";
    import EscenarioOpcionComponente from "./Componentes/EscenarioOpcionComponente";
    import EscenarioSeleccionComponente from "./Componentes/EscenarioSeleccionComponente";

    export default {
        name: "EscenarioFachadaRehabilitacion",
        model: {
            prop: 'correcto',
            event: 'change'
        },
        props: {
            escenario: {type: Object, required: true},
            correcto: {type: Boolean, default: false}
        },
        components: {
            EscenarioOpcionComponente,
            EscenarioSeleccionComponente
        },
        data: function () {
            return {
                provincias: [],
                altitudes: [],
                anyosConstruccion: [],
                estadosConservacion: [],
                revestimientos: [],
            }
        },
        mounted() {
            this.obtenerZonasClimaticas();
            this.obtenerAnyosConstruccion();
            this.obtenerEstadosConservacion();
            this.obtenerRevestimientos();

            let auxAltitude = this.escenario.altitude;
            if (auxAltitude !== null)
                this.obtenerAltitudes().then(() => {
                    this.altitudes.forEach((altitud) => {
                        if (altitud.descripcion == auxAltitude) this.escenario.altitude = altitud;
                    });
                });
            this.emitirCorrecto(this.escenarioEsCorrecto(this.escenario));
        },
        watch: {
            escenario: {
                handler(val) {
                    this.emitirCorrecto(this.escenarioEsCorrecto(val));
                },
                deep: true
            }
        },
        methods: {
            obtenerZonasClimaticas() {
                HttpHelper.get('fachada/zona-climatica/provincias')
                    .then(data => {
                        this.provincias = data;
                    });
            },
            obtenerAltitudes() {
                if (this.escenario.province === null) return;

                this.altitudes = [];
                this.escenario.altitude = null;
                let promise = HttpHelper.get(`fachada/zona-climatica/altitud-por-provincia/${this.escenario.province.codigo}`);
                promise.then(data => {
                    for (let i = 0; i < data.length; i++) {
                        data[i].descripcionVista = data[i].descripcion === "desc"
                            ? "Desconocida" : data[i].descripcion + " metros";
                    }
                    this.altitudes = data;
                });

                return promise;
            },
            obtenerAnyosConstruccion() {
                HttpHelper.get('fachada/rehabilitacion/anyo-construccion')
                    .then(data => {
                        this.anyosConstruccion = data;
                    });
            },
            obtenerEstadosConservacion() {
                HttpHelper.get('fachada/rehabilitacion/estado-conservacion')
                    .then(data => {
                        this.estadosConservacion = data;
                    });
            },
            obtenerRevestimientos() {
                HttpHelper.get('fachada/rehabilitacion/revestimiento')
                    .then(data => {
                        this.revestimientos = data;
                    });
            },
            seleccionarProvincia(provincia) {
                this.escenario.province = provincia;
                this.escenario.altitude = null;
                this.escenario.climaticZone = null;
                this.obtenerAltitudes();
            },
            seleccionarAltitud(altitud) {
                this.escenario.altitude = altitud;
                this.escenario.climaticZone = {'codigo': altitud.codigo};
            },
            seleccionarAnyoConstruccion(anyoConstruccion) {
                this.escenario.yearConstruction = anyoConstruccion;
            },
            seleccionarConservacion(conservacion) {
                this.escenario.stateConservation = conservacion;
            },
            seleccionarRevestimiento(revestimiento) {
                this.escenario.existingCoating = revestimiento;
            },
            emitirCorrecto(value) {
                this.$emit('change', value);
            },
            escenarioEsCorrecto(escenario) {
                let params = [
                    escenario.province,
                    escenario.altitude,
                    escenario.climaticZone,
                    escenario.yearConstruction,
                    escenario.stateConservation
                ];

                let someNull = false;
                params.forEach((item) => {
                    if (item == null) someNull = true;
                });
                if (someNull) return false;

                if (escenario.stateConservation.code === 'facade_deteriorated' && escenario.existingCoating === null)
                    return false;

                return true;
            },
        }
    }
</script>

<style scoped>
    select {
        margin: 0;
    }
</style>

<!-- @formatter:off -->
<i18n>
    {
    "es": {
    "selecciona_altitud": "Selecciona una altitud",
    "ubicacion": "Ubicación",
    "provincia": "Provincia",
    "provincia_descrip":"Para poder definir el espesor del aislante térmico a incorporar en la fachada es necesario definir su situación geográfica.",
    "altitud": "Altitud (metros)",
    "altitud_descrip":"Para poder definir el espesor del aislante térmico a incorporar en la fachada es necesario definir su altitud respecto al nivel del mar",
    "selec_provincia_antes": "Debes seleccionar una provincia primero.",
    "climatica_consid": "Zona climática considerada",
    "anyo_construccion": "Año de construcción",
    "anyo_construccion_descrip": "Selección de la época de construcción del edificio para calcular el espesor del aislante térmico necesario según la fachada tipo considerada.",
    "conservacion": "Estado de conservación",
    "conservacion_descrip": "En función del sistema de fachada elegido para la rehabilitación, será necesario conocer el estado de conservación de la fachada existente",
    "revestimiento": "Revestimiento existente",
    "revestimiento_descrip": " "
    }
    }
</i18n>
<!-- @formatter:on -->